<template>
	<div class="memberBenefits-container">
		<div class="memberBenefits-main">
			<div class="memberBenefits-content">
				<div class="term-banner"></div>
				<div class="term-content">
					<h3 class="memberBenefits-title">会员升级及权益变更法律说明</h3>
					<div class="term-box">
						<div class="term-text">
							<div class="term-item">
								<div class="term-number">1</div>
								<div class="term-desc">
									<b>会员升级流程</b>
									<p>
										当用户已办理高级会员并希望升级为超级会员时，需按照平台规定支付高级会员与超级会员之间的差价费用。支付完成后，用户的会员等级将自动从高级会员变更为超级会员。
									</p>
								</div>
							</div>

							<div class="term-item">
								<div class="term-number">2</div>
								<div class="term-desc">
									<b>权益变更</b>
									<p>
										会员等级升级后，用户将享受超级会员所提供的全部功能和权益，包括但不限于增加的服务次数、专属优惠等。
									</p>
									<p>
										关于服务次数，用户在升级为超级会员后，其服务次数将重置为超级会员所享有的次数。此前在高级会员期间已使用的服务次数将不计入超级会员的服务次数中。
									</p>
								</div>
							</div>

							<div class="term-item">
								<div class="term-number">3</div>
								<div class="term-desc">
									<b>法律适用与争议解决</b>
									<p>
										本法律说明的解释、效力及争议解决均适用中华人民共和国法律。
									</p>
									<p>
										如因本法律说明产生任何争议，双方应首先通过友好协商解决。协商不成的，任何一方均有权向平台所在地人民法院提起诉讼。
									</p>
								</div>
							</div>

							<div class="term-item">
								<div class="term-number">4</div>
								<div class="term-desc">
									<b>其他条款</b>
									<p>
										平台保留对本法律说明进行修订和解释的权利。任何修订和解释均将以平台公告的形式通知用户。
									</p>
									<p>
										用户在升级会员等级前，请务必仔细阅读并理解本法律说明的内容。一旦完成支付并升级会员等级，即视为用户已同意并接受本法律说明的约束。
									</p>
									<p>
										我们始终致力于为您提供更加贴心和个性化的服务，希望这次会员升级能为您带来更加愉悦的观影体验。如有任何疑问或需要帮助，请随时联系我们的客服团队，我们将竭诚为您解答。
									</p>
								</div>
							</div>

							<p class="conclusion">
								再次感谢您的支持与信任，期待与您一起探索更多精彩内容！
							</p>

							<div class="term-footer">
								<div class="platform-name">楚建通</div>
								<div class="publish-date">发布日期：2025年7月18日</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// 会员升级及权益变更法律说明
	export default {
		name: 'Law',
		components: {},
		props: {},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	.memberBenefits-container {
		background-color: #f7f7f7;

		.memberBenefits-content {
			.term-banner {
				height: 400px;
				background: url('~@/assets/memberBenefits/banner.jpg') 50% 50% no-repeat;
				background-size: cover;
			}

			.term-content {
				width: $main-page-width;
				margin: 0 auto;
				padding: 50px 0;

				.term-box {
					background-color: #fff;
					border-radius: 10px;
					box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
					padding: 40px 60px;

					.term-text {
						font-size: 16px;
						color: #333;
						line-height: 1.8;

						.greeting {
							font-size: 18px;
							margin-bottom: 20px;
						}

						.intro,
						.conclusion {
							margin-bottom: 30px;
						}

						.term-item {
							display: flex;
							margin-bottom: 25px;

							.term-number {
								width: 30px;
								height: 30px;
								background: linear-gradient(90deg, #ffc664 0%, #ff9538 100%);
								border-radius: 50%;
								color: #fff;
								font-weight: bold;
								display: flex;
								align-items: center;
								justify-content: center;
								margin-right: 15px;
								flex-shrink: 0;
								margin-top: 3px;
							}

							.term-desc {
								flex: 1;

								b {
									color: #934e25;
									font-size: 17px;
								}

								p {
									margin: 8px 0;
								}
							}
						}
					}
				}
			}
		}

		.memberBenefits-title {
			font-size: 26px;
			color: #333;
			text-align: center;
			margin-bottom: 40px;
			position: relative;

			&::after {
				content: '';
				display: block;
				width: 60px;
				height: 3px;
				background: linear-gradient(90deg, #ffc664 0%, #ff9538 100%);
				margin: 15px auto 0;
			}
		}

		.term-footer {
			margin-top: 40px;
			text-align: right;
			font-size: 16px;
			color: #666;
			border-top: 1px solid #eee;
			padding-top: 20px;

			.platform-name {
				font-weight: bold;
				margin-bottom: 5px;
			}

			.publish-date {
				font-style: italic;
			}
		}
	}
</style>
